import script from "./BotVariablePickerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BotVariablePickerModal.vue?vue&type=script&setup=true&lang=js"

import "./BotVariablePickerModal.vue?vue&type=style&index=0&id=50c34bbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c34bbf"]])

export default __exports__